import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";

import SuccessBanner from "../../components/SuccessBanner";
import {
  BLOCKED_MESSAGE_MAX_LENGTH,
  useMutateSaveBlockedMessage,
  useQueryGetBlockedMessage,
} from "../../data/services/portalSettingService";

// Admin editor for the message shown to clients on the Feature Access Control
// "blocked" list. Global across OE periods.
const BlockedMessageSetup = () => {
  const { data, isLoading, isError } = useQueryGetBlockedMessage();
  const saveHandler = useMutateSaveBlockedMessage();

  const savedMessage = data?.data?.message ?? "";
  // null = untouched, so the box follows the saved value until the user types.
  const [draft, setDraft] = React.useState(null);
  const value = draft ?? savedMessage;

  const trimmedLength = value.trim().length;
  const isValid = trimmedLength > 0 && trimmedLength <= BLOCKED_MESSAGE_MAX_LENGTH;
  const isDirty = value.trim() !== savedMessage;

  const onSave = async () => {
    try {
      await saveHandler.mutateAsync(value.trim());
      setDraft(null);
    } catch {
      // Surfaced via saveHandler.isError below.
    }
  };

  return (
    <div>
      <h2>Blocked Client Message</h2>
      <p>
        Shown to clients on the Feature Access Control "blocked" list instead of
        the portal. Applies to every OE period and takes effect immediately.
      </p>
      <SuccessBanner message="Message saved successfully" handler={saveHandler} />
      {isError && (
        <div
          style={{
            backgroundColor: "#f8d7da",
            padding: 10,
            marginBottom: 10,
            borderRadius: ".25rem",
            color: "#721c24",
          }}
        >
          Unable to load the current message.
        </div>
      )}
      {saveHandler.isError && (
        <div
          role="alert"
          style={{
            backgroundColor: "#f8d7da",
            padding: 10,
            marginBottom: 10,
            borderRadius: ".25rem",
            color: "#721c24",
          }}
        >
          Unable to save the message. Please try again.
        </div>
      )}
      <textarea
        aria-label="Blocked client message"
        data-testid="blocked-message-input"
        value={value}
        disabled={isLoading}
        onChange={(event) => setDraft(event.target.value)}
        rows={5}
        style={{ width: "100%", maxWidth: 800, padding: 8, fontSize: 14 }}
      />
      <div
        data-testid="blocked-message-count"
        style={{ color: trimmedLength > BLOCKED_MESSAGE_MAX_LENGTH ? "#721c24" : "#555" }}
      >
        {trimmedLength} / {BLOCKED_MESSAGE_MAX_LENGTH}
      </div>
      <div style={{ paddingTop: 20 }}>
        <Button
          themeColor={"success"}
          disabled={!isValid || !isDirty || saveHandler.isLoading}
          onClick={onSave}
        >
          {"Save Message"}
        </Button>
      </div>
    </div>
  );
};

export default BlockedMessageSetup;
